import React from 'react';

import type { HiddenInput as Props } from './hidden-input.types';

const HiddenInput: React.FC<Props> = ({ name, value }) => (
  <input name={name} type="hidden" value={value} />
);

export default HiddenInput;
